import { ClientFlagsProvider, OnUpdateClientFlags } from '@sdk/session/ClientFlagsContext';
import useToast from '@sdk/common/toast/useToast';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import { CurrencyProvider } from '@sdk/common/currency/CurrencyContext';

import useStepsConfig from '@web/onboarding/Checklist/hooks/useStepsConfig';
import OnboardingChecklist, { Props } from '@web/onboarding/Checklist/OnboardingChecklist';
import { shouldShowOnboardingChecklist } from '@web/onboarding/Checklist/onboardingChecklistGuard.utils';

type GuardProps = Props & { onUpdateClientFlags: OnUpdateClientFlags };

const OnboardingChecklistGuard = ({ onUpdateClientFlags, ...props }: GuardProps) => {
  const { availableSteps } = useStepsConfig();
  const { showErrorToast } = useToast();
  const allEventsParsed = props.allEvents ? props.allEvents : [];

  const onUpdateClientFlagsFailure = (error: string) => {
    showErrorToast(error);
  };

  return (
    <ClientFlagsProvider
      onUpdateClientFlags={onUpdateClientFlags}
      onUpdateClientFlagsFailure={onUpdateClientFlagsFailure}>
      {shouldShowOnboardingChecklist(props.currentUser, availableSteps) ? (
        <AuthProvider currentUser={props.currentUser}>
          <CurrencyProvider>
            <OnboardingChecklist {...props} allEvents={allEventsParsed} />
          </CurrencyProvider>
        </AuthProvider>
      ) : null}
    </ClientFlagsProvider>
  );
};

export default OnboardingChecklistGuard;
